import { RenderPlatformProps } from "../types/types";
import InitPerson from "./InitPerson";
import "../../styles/HotelRenderPlatform.css";

const RenderPlatform = ({
  UIcolumns,
  gameStyle,
  isGameStarted,
  roundState,
  selectedRoom,
  selectedErrorRoom,
  setSelectedErrorRoom,
  setSelectedRoom,
}: RenderPlatformProps) => {
  return (
    <>
      {UIcolumns.map((item) => (
        <div key={item.name} className={`hotel-platform hotel-${item.name}`}>
          {item.rooms.map((room) => {
            const isSelected =
              selectedRoom?.column === room.column &&
              selectedRoom?.roomId === room.id;
            const isSelectedError =
              selectedErrorRoom?.column === room.column &&
              selectedErrorRoom?.roomId === room.id;
            const windowType =
              item.name === "e"
                ? room.id === 1
                  ? "window_short_up"
                  : "window_short"
                : "window";

            const windowSrc = room.lightOn
              ? `/img/stevehotel/window/${windowType}_light.svg`
              : `/img/stevehotel/window/${windowType}_grey.svg`;

            const closedWindowSrc = `/img/stevehotel/window/${windowType}_close.svg`;

            return (
              <div
                key={`${room.column}-${room.id}`}
                className={`hotel-character hotel-${5 - room.id}  `}
                onClick={() => {
                  if (
                    gameStyle !== "adress" ||
                    !isGameStarted ||
                    roundState !== "playing"
                  )
                    return;
                  setSelectedErrorRoom(null);
                  setSelectedRoom({
                    column: room.column,
                    roomId: room.id,
                  });
                }}
              >
                {/* ===== ORBITAL ===== */}
                {gameStyle === "orbital" && (
                  <>
                    {room.isOpen && (
                      <>
                        <img
                          alt="window"
                          className="hotel-windowimg"
                          src={windowSrc}
                        />

                        {room.characterId && (
                          <img
                            data-testid={`character-${room.characterId}`}
                            alt={`character-${room.characterId}`}
                            className="hotel-characterimg"
                            src={
                              item.name === "e"
                                ? InitPerson[room.characterId - 1].svgDPurl
                                : InitPerson[room.characterId - 1].svgUrl
                            }
                          />
                        )}
                      </>
                    )}
                  </>
                )}

                {/* ===== ADRESS ===== */}
                {gameStyle === "adress" && (
                  <>
                    <div className="hotel-blindsWrapper">
                      <img
                        alt="closed window"
                        className={`hotel-windowimg hotel-blinds ${
                          room.isOpen ? "open" : ""
                        } ${isSelected ? "hotel-selectedRoom" : ""} ${isSelectedError ? "hotel-selectedErrorRoom" : ""}`}
                        src={closedWindowSrc}
                      />
                    </div>

                    {room.isOpen && (
                      <>
                        <img
                          alt="window"
                          className="hotel-windowimg"
                          src={windowSrc}
                        />

                        {room.characterId && (
                          <img
                            alt=""
                            className="hotel-characterimg"
                            src={
                              item.name === "e"
                                ? InitPerson[room.characterId - 1].svgDPurl
                                : InitPerson[room.characterId - 1].svgUrl
                            }
                          />
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </>
  );
};

export default RenderPlatform;
